import { render, staticRenderFns } from "./AffiliateLinksModal.vue?vue&type=template&id=4803abf8"
import script from "./AffiliateLinksModal.vue?vue&type=script&lang=js"
export * from "./AffiliateLinksModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports